module.exports = __webpack_public_path__ + "img/admin.21d2b2de.png";